export default __webpack_public_path__ + "static/media/creervotreentreprise.a76f23fa.jpg";